import { render, staticRenderFns } from "./FileIndexer.vue?vue&type=template&id=56f8d741&scoped=true"
import script from "./FileIndexer.vue?vue&type=script&lang=js"
export * from "./FileIndexer.vue?vue&type=script&lang=js"
import style0 from "./FileIndexer.vue?vue&type=style&index=0&id=56f8d741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8d741",
  null
  
)

export default component.exports